// Tagline.js

import React from "react";
import "./Tagline.css";
import "./Fonts.css";

export default function Tagline() {
  return (
    <div className="tagline">
      <h1>"Your One-Stop Print Solution "</h1>
      <hr className="separator" />
      <h1 className="gallery-heading">Gallery</h1>
    </div>
  );
}
